//@flow
const debug = require('../debug/debug')('wc:protocol:Storage');

export default class Storage {
  static get(key: string): any {
    try {
      return localStorage.getItem(key);
    } catch (err) {
      debug(err);
    }
  }

  static getNumber(key: string): any {
    const value = Storage.get(key);
    if (!value) {
      return null;
    }

    const parsedVal = Number(value);
    if (isNaN(parsedVal)) {
      return null;
    }

    return parsedVal;
  }

  static set(key: string, val: any) {
    try {
      return localStorage.setItem(key, val);
    } catch (err) {
      debug(err);
    }
  }

  static removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      debug(err);
    }
  }

  static setSessionStorage(key: string, val: any) {
    try {
      return sessionStorage.setItem(key, val);
    } catch (err) {
      debug(err);
    }
  }

  static removeSessionStorage(key: string) {
    try {
      return sessionStorage.removeItem(key);
    } catch (err) {
      debug(err);
    }
  }

  static getSessionStorage(key: string): any {
    try {
      return sessionStorage.getItem(key);
    } catch (err) {
      debug(err);
    }
  }
}
